var IMAGE_ASSET_PATHS = {
    ERROR_IMAGE: 'assets/rewards-mfe/cat-error.png',
    NOT_FOUND: 'assets/rewards-mfe/not-found.png',
    JCREW_BOX_ICON: 'assets/jcrew/box.svg',
    JCREW_CAKE_ICON: 'assets/jcrew/cake.svg',
    JCREW_STAR_ICON: 'assets/jcrew/stars.svg',
    SPARKS_ANIMATION: 'assets/rewards-mfe/sparkleLoop.gif'
};
export default IMAGE_ASSET_PATHS;
